import BlogCollectionPreview from "./BlogCollectionPreview";

const BlogCollectionPreviewWithProps = ({ blok }) => {
  return (
    <BlogCollectionPreview collection={blok.blogCollection} hideLinkToCollectionPage={blok.hideLinkToCollectionPage} />
  );
};

export default BlogCollectionPreviewWithProps;
